import React from "react"
import styled from "styled-components";

const SectionTitle = ({title, subheading}) => {
    return(
        <>
            <Title className="mb-4">{title}</Title>
            {subheading && <p className="text-center"> {subheading} </p>}
        </>
    )
}

export default SectionTitle;

const Title = styled.h2`
  text-align: center;
  color: var(--primary-color);
  font-size: 1.8rem;
  font-weight: medium;
  position: relative;
  &:before,
  &:after {
    content: "";
    display: inline-block;
    width: 120px;
    height: 2px;
    background: var(--secondary-color);
    vertical-align: middle;
    margin: 0 15px;
  }
`;